import React from 'react';
import styled from 'styled-components';
import { AppointmentStatus } from '@bb/domain/dist/types';
import { Row, Col, Form, Checkbox, type FormInstance } from '@bb/elements-web';

const DISPLAY_STATUSES: Partial<Record<AppointmentStatus, string>> = {
  new: 'New',
  attempted: 'Attempted',
  confirm: 'Confirmed',
  deny: 'Denied',
  cancel: 'Cancelled',
  time_change: 'Time Change',
  time_passed: 'Time Passed',
};

interface AppointmentPreferencesTabProps {
  form: FormInstance;
}

const AppointmentPreferencesTab: React.FC<AppointmentPreferencesTabProps> = ({
  form,
}) => (
  <Form dataCy="appointment-preferences-form" form={form} layout="vertical">
    <Row>
      <Col xs={{ span: 24 }} md={{ span: 12 }}>
        {Object.entries(DISPLAY_STATUSES).map(([status, label]) => (
          <StyledFormItem
            key={status}
            name={['appointmentPreferences', status]}
            valuePropName="checked"
          >
            <StyledCheckbox data-cy={`${status}-checkbox`}>
              {label}
            </StyledCheckbox>
          </StyledFormItem>
        ))}
      </Col>
      <Col xs={{ span: 24 }} md={{ span: 12 }}>
        <StyledFormItemOuter label="Display Status Filters">
          <StyledFormItem
            name={['additionalShowingPreferences', 'mustCall']}
            valuePropName="checked"
          >
            <StyledCheckbox data-cy="mustCall-checkbox">
              Must Call
            </StyledCheckbox>
          </StyledFormItem>
        </StyledFormItemOuter>
        <StyledFormItemOuter label="Alternative Filter">
          <StyledFormItem
            name={['additionalShowingPreferences', 'customContact']}
            valuePropName="checked"
          >
            <StyledCheckbox data-cy="customContact-checkbox">
              Custom Contact Booked Showings
            </StyledCheckbox>
          </StyledFormItem>
          <StyledFormItem
            name={['additionalShowingPreferences', 'homeInspection']}
            valuePropName="checked"
          >
            <StyledCheckbox data-cy="homeInspection-checkbox">
              Home Inspection
            </StyledCheckbox>
          </StyledFormItem>
        </StyledFormItemOuter>
      </Col>
    </Row>
  </Form>
);

export default AppointmentPreferencesTab;

const StyledCheckbox = styled(Checkbox)`
  &&& {
    margin: 0;
  }
` as typeof Checkbox;

const StyledFormItem = styled(Form.Item)`
  &&& {
    margin-bottom: 2px;
  }
` as typeof Form.Item;

const StyledFormItemOuter = styled(Form.Item)`
  &&& {
    & .ant5-form-item-label > label,
    & .ant-form-item-label > label {
      font-weight: 600;
    }
  }
` as typeof Form.Item;
